export default __webpack_public_path__ + "static/media/f5.f326cfcd.svg";